export default "__VITE_ASSET__BAPNsh6P__"